import { AxiosInstance } from 'axios';

import { GetUrlResponse } from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/upload';

export class UploadServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  createUpload(params: types.CreateUploadParameters): Promise<types.CreateUploadResponse> {
    throw new Error('Method not implemented.');
  }
  completeUpload(params: types.CompleteUploadParameters): Promise<types.Upload> {
    throw new Error('Method not implemented.');
  }

  async exportUpload(params: types.ExportUploadParameters): Promise<GetUrlResponse> {
    return (
      await this.axios.get<Promise<GetUrlResponse>>(`/v1/uploads/${String(params.path.id)}`, {
        params: params.query,
      })
    ).data;
  }
}
